export const getEmployee = (state, id) => state.employee.employees.entries[id];
